import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";

class PatientIdentifier {
    // HealthCard Only
    public IsHealthCard: boolean;
    public ExpiryDate: Date;
    public ProvinceLookupId: string;
    // ---------------

    public HealthIdentification_id: string;
    public OtherIdentification_id: string;
    public Number: string;
    public Name: string;
    public AdditionalInfo: string;
    public Version: string;
    public CountryLookupId: string;
    public AvailableCountryLookups: FlatLookupView[];
    public AvailableCountryRegionLookups: FlatLookupView[];

    // Validation:
    public IsValid: boolean = true;
}

export { PatientIdentifier };
